import React, { useEffect, useRef, useState, useCallback } from 'react';
import { request } from 'lib/request';
import { Doctor } from 'types/entity';
import { Title } from 'components/Title/Title';
import { cdn } from 'core/cdn';
import Styles from './consultingDoctors.module.scss'
import { languages } from 'lib/languages';

const getSexLabel = (sex: boolean | number) => (sex === 0 || sex === false) ? 'Mme.' : 'M.'

const ConsultingDoctors = () => {
  const [doctors, setDoctors] = useState<Array<Doctor>>([]);
  const [total, setTotal] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const observerTarget = useRef<HTMLDivElement>(null);


  useEffect(() => {
    request('/liberal/doctors?limit=50&category_id=6,7&page=0', { method: 'GET' }).then((res: { total: number, doctors: Array<Doctor> }) => {
      setDoctors(res?.doctors);
      setTotal(res?.total);
    })
  }, [])

  const loadMore = useCallback(() => {
    if (doctors.length + (50 * page - 1) < total) {
      request(`/liberal/doctors?limit=50&category_id=6,7&page=${page + 1}`, { method: "GET" }).then((res: { total: number, doctors: Array<Doctor> }) => {
        setDoctors(res?.doctors);
        setTotal(res?.total);
        setPage(prev => prev + 1)
      })
    }
  }, [doctors.length, total, page])

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting) {
          loadMore();
        }
      },
      { threshold: 0.1 }
    );
    if (observerTarget.current) {
      observer.observe(observerTarget.current);
    }
    return () => observer.disconnect();
  }, [loadMore]);

  return (
    <div>
      <div className={Styles.Content}>
        <Title text={languages.consultingDoctors} />
        <div>
          {
            doctors && doctors?.length > 0 && doctors.map((doctor: Doctor) => {
              return (
                <div className={Styles.Card}>
                  <div className={Styles.CardContainer}>
                    <img src={cdn((doctor?.sex === 0 || doctor.sex === false) ? '/images/female_doctor.svg' : '/images/male_doctor.svg')} alt="doctor" width={96} style={{ marginLeft: '15px' }} />
                    <div className={Styles.DoctorInfoContainer}>
                      <div>Dr. ({getSexLabel(doctor.sex as boolean)}) {doctor.firstname} {doctor?.lastname?.toUpperCase()}</div>
                      <div className={Styles.SubText}>{doctor.category_display || languages.doctorType(doctor?.category_id)}</div>
                      <div className={Styles.SubText}>{languages.firstOnsiteAddress}{doctor.onsite_address}</div>
                    </div>
                  </div>
                </div>
              )
            })
          }
          <div ref={observerTarget} className={Styles.ObserverTarget} />
        </div>
      </div>
    </div>
  )
}

export default ConsultingDoctors;